import React, { useState } from 'react'
import {
  Badge,
  Button,
  Icon,
  ListItemIcon,
  ListItemText,
  Popover,
  MenuItem,
  Typography,
  Link,
} from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'
import { CrispContext } from 'commons/useCrisp'
import { useIntl } from 'react-intl'
import publicUrlConfig from 'app/configs/publicUrlConfig'
import { FeatureHighlightsIcon } from 'app/components/icons'
import { onHandleFeatureHighlights } from 'app/auth/store/actions'
import { useDispatch } from 'react-redux'

// to do arg theme
const useStyle = makeStyles(() => ({
  text: {
    color: '#3A3A3A !important',
  },
  icon: {
    color: '#3A3A3A !important',
  },
  menuLink: {
    '&:hover': {
      textDecoration: 'initial',
    },
    color: 'inherit',
  },
}))

function LanguageMenuSwitcher(props) {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const classes = useStyle(props)
  const [isMenuOpened, setIsMenuOpened] = useState(null)
  const closeMenu = R.compose(setIsMenuOpened, R.always(null))

  return (
    <CrispContext.Consumer>
      {/* to do arg handleToggleChat */}
      {({ hasUnreadMessage }) => (
        <>
          <Button onClick={R.compose(setIsMenuOpened, R.prop('currentTarget'))}>
            <div className="flex flex-col items-start">
              <Typography
                component="span"
                className={clsx(classes.text, 'normal-case font-600 flex')}
              >
                <Badge
                  color="error"
                  variant="dot"
                  invisible={!hasUnreadMessage}
                >
                  <Icon>help_outline</Icon>
                </Badge>
              </Typography>
            </div>
          </Button>

          <Popover
            open={Boolean(isMenuOpened)}
            anchorEl={isMenuOpened}
            onClose={closeMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            classes={{
              paper: 'py-8',
            }}
          >
            <MenuItem
              component={Link}
              href={publicUrlConfig.PUBLIC_URL_GETTING_STARTED}
              target="_blank"
            >
              <ListItemIcon>
                <Badge
                  color="error"
                  variant="dot"
                  invisible={!hasUnreadMessage}
                >
                  <img alt="Auto fix high icon" src={Assets.autoFixHigh} />
                </Badge>
              </ListItemIcon>
              <ListItemText
                className="ltr:pl-0 rtl:pr-0"
                primary={formatMessage({ id: 'menu.guidelines.started' })}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                dispatch(onHandleFeatureHighlights(true))
              }}
            >
              <ListItemIcon>
                <FeatureHighlightsIcon />
              </ListItemIcon>
              <ListItemText
                className="ltr:pl-0 rtl:pr-0"
                primary={formatMessage({
                  id: 'menu.guidelines.feature.highlights',
                })}
              />
            </MenuItem>
            <MenuItem
              component={Link}
              href={publicUrlConfig.PUBLIC_URL_FAQ}
              target="_blank"
            >
              <ListItemIcon>
                <Badge
                  color="error"
                  variant="dot"
                  invisible={!hasUnreadMessage}
                >
                  <img alt="Question answer icon" src={Assets.questionAnswer} />
                </Badge>
              </ListItemIcon>
              <ListItemText
                className="ltr:pl-0 rtl:pr-0"
                primary={formatMessage({ id: 'menu.guidelines.faq' })}
              />
            </MenuItem>
            <MenuItem
              component={Link}
              href={publicUrlConfig.PUBLIC_URL_TROUBLE_SHOOTING_GUIDE}
              target="_blank"
            >
              <ListItemIcon>
                <Badge
                  color="error"
                  variant="dot"
                  invisible={!hasUnreadMessage}
                >
                  <img
                    alt="Screen search desktop icon"
                    src={Assets.screenSearchDesktop}
                  />
                </Badge>
              </ListItemIcon>
              <ListItemText
                className="ltr:pl-0 rtl:pr-0"
                primary={formatMessage({
                  id: 'menu.guidelines.shooting.guide',
                })}
              />
            </MenuItem>
          </Popover>
        </>
      )}
    </CrispContext.Consumer>
  )
}

export default LanguageMenuSwitcher
